var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "select-table-wrapper" },
    [
      _c("b-table", {
        staticClass: "w-100 h-100 items-table",
        attrs: {
          "table-class": "h-100",
          "empty-text": "No items",
          "select-mode": "single",
          "show-empty": "",
          selectable: "",
          striped: "",
          hover: "",
          responsive: "",
          fields: _vm.fields,
          items: _vm.items,
        },
        on: { "row-selected": _setup.itemSelected },
        scopedSlots: _vm._u(
          [
            _vm._l(_setup.slots, function (_, slotName, index) {
              return {
                key: slotName,
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { key: `${slotName}-${index}` },
                      [_vm._t(slotName, null, null, scope)],
                      2
                    ),
                  ]
                },
              }
            }),
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }